import isEmpty from "lodash/isEmpty";
import validate from "validate.js";
import { validateFieldWithKey } from "../../utils/findAndValidateField";
import { constraints } from "../../utils/validation";

const licenseValidation = {
    licenseName: {
        ...constraints.required,
    },
    licenseNumber: {
        ...constraints.required,
    },
    licenseStateCode: {
        ...constraints.required,
    },
};

const exhibitAValidation = {
    exhibitAExpirationDate: {
        ...constraints.required,
        ...constraints.date,
    },
    exhibitAType: {
        ...constraints.required,
    },
    annualGrossMinimum: {
        ...constraints.required,
    },
    adjustedPercentage: {
        ...constraints.required,
    },
    baseSplitPercentage: {
        ...constraints.required,
    },
    exhibitAStartDate: {
        ...constraints.date,
    },
};

export const exhibitANonRequiredValidation = {
    exhibitAExpirationDate: {
        ...constraints.date,
    },
    exhibitAStartDate: {
        ...constraints.date,
    },
}

const companyValidation = {
    legalName: {
        ...constraints.required,
    },
    displayName: {
        ...constraints.required,
    },
    companyTypes: {
        ...constraints.required,
    },
};

const userAccountValidation = {
    role: {
        ...constraints.required,
    },
};

const userProxy = {
    proxyFor: {
        ...constraints.required,
    },
};
const validateLicenseDetail = (values) => {
    return validate(values, licenseValidation, { fullMessages: false });
};

const validateExhibitADetail = (values) => {
    return validate(values, exhibitAValidation, { fullMessages: false });
};

const validateUserAccountDetail = (values) => {
    return validate(values, userAccountValidation, { fullMessages: false });
};
const validateUserProxyDetail = (values) => {
    return validate(values, userProxy, { fullMessages: false });
};

const validateCompanyDetail = (values) => {
    return validate(values, companyValidation, { fullMessages: false });
};

const validateCompanyField = (id, value) => {
    const { fullKey, result } = validateFieldWithKey(companyValidation, id, value);
    if (!fullKey) return [{ fullKey: null, resolved: false }];
    return [{ fullKey: "company." + fullKey, resolved: isEmpty(result) }];
};

const userAdminValidationSections = {
    exhibitAValidation,
    licenseValidation,
};

const validateUserAdminField = (section, id, value) => {
    const constraintsObj = userAdminValidationSections[section];
    if (!constraintsObj) return [{ fullKey: id, resolved: true }];
    const field = id.split(".").pop();
    const { result } = validateFieldWithKey(constraintsObj, field, value);
    return [{ fullKey: id, resolved: isEmpty(result) }];
};

export default {
    validateLicenseDetail,
    validateExhibitADetail,
    validateUserAccountDetail,
    validateUserProxyDetail,
    validateCompanyDetail,
    validateCompanyField,
    validateUserAdminField,
};
